@if (showTerug()) {
	<app-button (clickit)="goBack()" buttonType="text" icon="chevron-left">Terug</app-button>
}
@if (qp.hasQueryParams()) {
	<app-button (clickit)="resetDashboard()" buttonType="text" icon="refresh">Reset</app-button>
}
<app-button icon="filter" (clickit)="openFilterPanel()">Filters</app-button>
<div class="filter-label">
	@for (filterId of filterIds(); track filterId) {
		@if (filterService.isVisible(filterName(filterId)) | async) {
			<app-filter-label [filterName]="filterName(filterId)" [hilite]="filterIdsNew().has(filterId)"></app-filter-label>
		}
	}
</div>
@if (dataRootSelection()) {
	<div class="save-selection-button" (click)="leerlingSelectieService.slaSelectieOp(dataRootSelection()!)">
		<app-icon name="add-user" color="primary-1" size="small"></app-icon>
		<span>Selectie opslaan ({{ dataRootSelection()!.size }})</span>
	</div>
}
